// extracted by mini-css-extract-plugin
export var container = "_12-0";
export var disabled = "_12-4";
export var fullWidth = "_12-3";
export var lined = "_12-1";
export var selected = "_12-5";
export var tab = "_12-2";